import {getAuthenticatedAresClient} from '@modifi/trade-api-clients'
import ms from 'ms'

const FILENAME_REGEX = /filename=(.*);?/i

export const downloadInvoice = () => async (type, externalId) => {
  const functionMap = {
    pdf: 'pdfById',
    csv: 'csvById',
  }
  const client = getAuthenticatedAresClient()
  return client.Invoices[functionMap[type]]({externalId, timeout: ms('60s')}).then(res => {
    const contentDisposition = res.header('Content-Disposition')
    const fileName = contentDisposition.match(FILENAME_REGEX)[1]
    return [fileName, res.data()]
  })
}
